import Path from '@leverege/path';
export default function FotaMutator(type, plugin, molten) {
  const {
    name,
    objectType
  } = plugin;
  if (type === 'Attribute') {
    const changes = molten.getConfig(`fotaMutator/${name}`);
    if (changes?.objectType === objectType && Array.isArray(changes?.patch)) {
      let mutated = plugin;
      changes.patch.forEach(({
        path,
        value
      }) => {
        mutated = Path.copy(path, mutated, value);
      });
      return mutated;
    }
  }
  return plugin;
}